import { useReveal, SpringParallax } from '@ccg/core';
import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React$1 from 'react';
import PropTypes$1 from 'prop-types';
import Typography$1 from '../../basics/Typography/Typography.js';
import BackgroundVideo$1 from '../BackgroundVideo/BackgroundVideo.js';
import StyledMainStage from './MainStage.style.js';

const MainStage = (_ref) => {
  let {
    headline,
    video
  } = _ref,
      props = _objectWithoutProperties(_ref, ["headline", "video"]);

  const [ref, isVisible] = useReveal();
  const splittedHeadline = headline.split('/');
  const randomHeadline = splittedHeadline[Math.floor(Math.random() * splittedHeadline.length)];
  return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, video && /*#__PURE__*/React$1.createElement(BackgroundVideo$1, {
    src: video
  }), /*#__PURE__*/React$1.createElement(StyledMainStage, _extends({
    ref: ref
  }, props), /*#__PURE__*/React$1.createElement(SpringParallax, {
    className: "mainStage__wrapper"
  }, /*#__PURE__*/React$1.createElement(Typography$1, {
    variant: "hero",
    as: "h1",
    reveal: true,
    isVisible: isVisible
  }, randomHeadline))));
};

MainStage.propTypes = {
  video: PropTypes$1.string,
  headline: PropTypes$1.string.isRequired
};
MainStage.defaultProps = {
  video: null
};

export default MainStage;
